import type { CompatibilityError } from '@/components/dashboard/widgets/CompatibilityBadge';
import { CompatibilityBadge } from '@/components/dashboard/widgets/CompatibilityBadge';

interface CompatibilityWarningProps {
  widgetId: string;
  error: CompatibilityError;
  onRequestFix: (opts: { widgetId: string; targetCols?: number; targetRows?: number }) => void;
}

export function CompatibilityWarning({ widgetId, error, onRequestFix }: CompatibilityWarningProps) {
  return (
    <div data-testid={`compat-warning-${widgetId}`} role="status" className="w-full">
      <CompatibilityBadge
        widgetId={widgetId}
        error={error}
        onRequestFix={onRequestFix}
      />
    </div>
  );
}

export default CompatibilityWarning;
